export enum ImageHorizontalPosition {
  LEFT = "Left",
  CENTRE = "Centre",
  RIGHT = "Right",
}
